import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { forkJoin } from 'rxjs';
import { Util } from 'src/app/app.util';
import { UserAccessService } from 'src/app/service/admin/user-access.service';

@Component({
  selector: 'app-user-access-request-details',
  templateUrl: './user-access-request-details.component.html',
  styleUrls: ['./user-access-request-details.component.css']
})
export class UserAccessRequestDetailsComponent implements OnInit {

  @BlockUI() blockUI : NgBlockUI;

  @ViewChild('dealerDetails') dealerDetailsTemplate:TemplateRef<any>;
  dealerDetailsModalRef: BsModalRef;

  @ViewChild('createStatus') createStatusTemplate:TemplateRef<any>;
  createStatusModalRef: BsModalRef;

  @ViewChild('copyUser') copyUserTemplate:TemplateRef<any>;
  copyUserModalRef: BsModalRef;

  @ViewChild('confirmCopyUser') confirmCopyUserTemplate:TemplateRef<any>;
  confirmCopyUserModalRef: BsModalRef;

  @ViewChild('confirmCreateUser') confirmCreateUserTemplate:TemplateRef<any>;
  confirmCreateUserModalRef: BsModalRef;

  @ViewChild('confirmDealerUpdate') confirmDealerUpdateTemplate:TemplateRef<any>;
  confirmDealerUpdateModalRef: BsModalRef;

  //tableLoader = true;
  recordId;
  requestDate : string;
  dealerName : string;
  phone : string;
  companyName : string;
  emailAddr : string;
  vendorCode : string

  roles : any;

  selectedDealer : any;
  selectedVendors : any;
  selectedCustomers : any;

  dealerSearch : string = '';
  customerSearch : string = '';
  userNameSearch : string = '';

  customerList : any;
  dealerList : any;
  vendorCodeList : any;
  userNameList : any;

  totalDealer = -1;
  totalVendor = -1;
  totalCustomer = -1;
  totalUser = -1;

  mainDealerDetailList : any = [];
  popupDealerDetailList : any = [];

  searchUserMessage = '';
  addDealerMessageList : any = [];
  
  errorDetails : any = {};

  dealerErrorDetails : any = {};


  createStatusMsg: string;
  confirmCopyUserMsg : string;

  copyUserFlag : string = 'N';
  copyUser : any;
  createStatusFlag: any;

  constructor(private router :Router, private route: ActivatedRoute, 
    private userAccessService : UserAccessService, private modalService: BsModalService,
    private util: Util) { }

  ngOnInit() {
    if (history.state) {

        //this.tableLoader = true;
        this.blockUI.start();
        this.recordId = history.state.recId;
        console.log('recId:', this.recordId);

        if(!this.recordId){
          this.router.navigate(['/accessList']);
        }

        let param = {
          "recordId" : this.recordId
        }

        this.userAccessService.getInitialData(param).subscribe(
          data => {

              if(data.status == 'S'){
                this.roles = data.roleList;

                let userReqDetails = data.userAccessReqDetails;
                this.vendorCode = userReqDetails.VENDOR_CODE;
                this.dealerName = userReqDetails.DEALER_NAME;
                this.companyName = userReqDetails.COMPANY_NAME;
                this.emailAddr = userReqDetails.EMAIL_ADDRESS;
                this.requestDate = userReqDetails.REQUEST_DATE;
                this.dealerName = userReqDetails.DEALER_NAME;
                this.phone = userReqDetails.PHONE_NO;
              }else{
                console.log("Unable to get the details.");
              }

              //this.tableLoader = false;
              this.blockUI.stop();
          }
        );
    }
  }


  cancelRequest(){
    this.router.navigate(['/accessList']); 
  }

  roleSelected(role:any) {
     role.SELECTED = !role.SELECTED;  
 
    let selectedRoleList = this.roles.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('selectedRoleList:' + selectedRoleList);
  }


  vendorSelected(vendor:any, event:any) {
    /* if (event.target['checked'] == true) {
      vendor.SELECTED = true;
    }else {
      vendor.SELECTED = false; 
    } */

    if (vendor.SELECTED == true) {
      vendor.SELECTED = false;
    }else if(vendor.SELECTED == false){
      vendor.SELECTED = true; 
    }  
    
    let selectedVendorCodeList = this.vendorCodeList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('selectedVendorCodeList:' + selectedVendorCodeList);
  }

  custSelected(cust:any, event:any) {
    /* if (event.target['checked'] == true) {
      cust.SELECTED = true;
    }else {
      cust.SELECTED = false; 
    } */

    if (cust.SELECTED == true) {
      cust.SELECTED = false;
    }else if (cust.SELECTED == false){
      cust.SELECTED = true; 
    }
    
    let selectedCustList = this.customerList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('selectedCustList:' + selectedCustList);
  }

  openDealerModal(){
    console.log('after openDealerModal');

    this.blockUI.start();

    /* if(this.copyUserFlag == 'Y'){
      this.mainDealerDetailList = [];
    } */

    /* this.roles.forEach(role => {
      role.SELECTED = false;
    }); */

    

    this.dealerSearch = this.companyName;

    this.vendorCodeList = [];
    this.totalVendor = -1
    this.customerSearch = '';
    this.customerList = [];
    this.totalCustomer = -1;

    this.dealerErrorDetails = {};

    this.selectedDealer = {};

    //this.popupDealerDetailList = this.mainDealerDetailList;

    if(this.copyUserFlag == 'N'){
      this.popupDealerDetailList = JSON.parse(JSON.stringify(this.mainDealerDetailList));
    }

    //this.copyUserFlag = 'N';

    this.dealerSearch = this.companyName;
    let paramDealer = {
      "DEALER_NAME" : this.companyName
    }

    this.customerSearch = this.companyName;
    let paramCust = {
      "CUST_TEXT" : this.companyName
    }

    const dealerDetails = this.userAccessService.getDealers(paramDealer);

    const custDetails = this.userAccessService.getCustList(paramCust);

    forkJoin([dealerDetails, custDetails]).subscribe(
      data => {

        console.log(data);
        this.clearDealerData();
        this.dealerList = data[0].dealerList;
        this.totalDealer = this.dealerList.length;

        
        this.clearCustData();
        this.customerList = data[1].custList;
        this.totalCustomer = this.customerList.length;

        this.blockUI.stop();

        //show the modal
        this.dealerDetailsModalRef = this.modalService.show(this.dealerDetailsTemplate, { class: 'modal-xl', backdrop : 'static', keyboard : false});

      }
    )
  }

  clearDealerData(){
    this.dealerList = [];
    this.totalDealer = -1;
    this.vendorCodeList = [];
    this.totalVendor = -1;
    delete this.dealerErrorDetails.missingDealerSearch;

  }

  searchDealers(){

    

    this.clearDealerData();

    if(!this.dealerSearch.trim()){
      this.dealerErrorDetails = { ...this.dealerErrorDetails, missingDealerSearch: 'Please provide dealer name.' };
      return;
    }
    
    this.blockUI.start();
    let param = {
      "DEALER_NAME" : this.dealerSearch.trim()
    }

    this.userAccessService.getDealers(param).subscribe(data => {

      if(data.status == 'S'){
        this.dealerList = data.dealerList;
        this.totalDealer = this.dealerList.length;
      }else{
        //this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }  
       this.blockUI.stop();
        
    }); 
  }

  clearCustData(){
    delete this.dealerErrorDetails.missingCustomerSearch; 
  }

  searchCust(){

    //this.tableLoader = true;
  
    this.clearCustData();
    
    if(!this.customerSearch.trim()){
      this.dealerErrorDetails = { ...this.dealerErrorDetails, missingCustomerSearch: 'Please provide customer details.' };
      return;
    }

    this.blockUI.start();
    let param = {
      "CUST_TEXT" : this.customerSearch.trim()
      //"CUST_TEXT" : 'ALLEN'
    }

    this.userAccessService.getCustList(param).subscribe(data => {

      if(data.status == 'S'){
        this.customerList = data.custList;
        this.totalCustomer = this.customerList.length;
      }else{
        //this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }  
      //this.tableLoader = false;    
      this.blockUI.stop();
    }); 
  }

  closeModal(modalType : string){
    if(modalType === 'dealer'){
      this.dealerDetailsModalRef.hide();
    }else if(modalType === 'createStatus'){
      this.createStatusModalRef.hide();
      this.router.navigate(['/accessList']); 
    }else if(modalType === 'copyUser'){
      //this.copyUserFlag = 'N';
      this.copyUserModalRef.hide();
    }else if(modalType === 'confirmCopyUser'){
      this.confirmCopyUserModalRef.hide();
    }else if(modalType === 'confirmCreateUser'){
      this.confirmCreateUserModalRef.hide();
    }else if(modalType === 'confirmDealerUpdate'){
      this.confirmDealerUpdateModalRef.hide();
    }
  }

  displayVendorCodes(dealerData){
    console.log('after displayVendorCodes');

    //this.tableLoader = true;
    this.blockUI.start();
    this.selectedDealer = dealerData;

    let param = {
      "DEALER_ID" : dealerData.DEALER_ID
    }

    this.userAccessService.getVendorCodes(param).subscribe(data => {

      if(data.status == 'S'){
        this.vendorCodeList = data.vendorCodeList;
        this.totalVendor = this.vendorCodeList.length;
      }else{
        //this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }  

      //this.tableLoader = false;
      this.blockUI.stop();
    });

  }

  validateDealerDetails(){

    this.addDealerMessageList = [];
    delete this.dealerErrorDetails.missingDealerDetails;

    console.log('here 1');
    let selectedVendorCodeList = this.vendorCodeList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('here 2');
    let selectedCustList = this.customerList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    if(!this.selectedDealer){
      this.addDealerMessageList.push('Please select a dealer.');
    }

    if(selectedVendorCodeList.length == 0){
      this.addDealerMessageList.push('Please select atleast one vendor code.');
    }

    if(selectedCustList.length == 0){
      this.addDealerMessageList.push('Please select atleast one customer.');
    }

    if(this.addDealerMessageList.length > 0){
      this.dealerErrorDetails = { ...this.dealerErrorDetails, missingDealerDetails: this.addDealerMessageList };
      return;
    }

    //Check if the dealer is already selected
    /* let dealerList = this.popupDealerDetailList.filter(function(item) {
      console.log('item.dealer.DEALER_ID:' + item.dealer.DEALER_ID);
      console.log('this.selectedDealer.DEALER_ID:' + this.selectedDealer.DEALER_ID);
      return item.dealer.DEALER_ID == this.selectedDealer.DEALER_ID;
    });  */

    let dealerList = [];

    this.popupDealerDetailList.filter(
      item => {
          console.log('this.selectedDealer.DEALER_ID:' + this.selectedDealer.DEALER_ID + "*");
          console.log('item.dealer.DEALER_ID:' + item.dealer.DEALER_ID + "*");
          console.log("condition:" + this.selectedDealer.DEALER_ID == item.dealer.DEALER_ID);
          if(this.selectedDealer.DEALER_ID == item.dealer.DEALER_ID ){
            console.log("Match!!");
            dealerList.push(item);
          }else{
            console.log("Do not Match");
          }
          
      });

    if(dealerList.length > 0){
      this.confirmDealerUpdateModalRef = this.modalService.show(this.confirmDealerUpdateTemplate, { backdrop : 'static', keyboard : false});
      return;
    }else{
      this.addDealerDetails('N');
      
    }
  }

  addDealerDetails(deleteFlag){

    if(deleteFlag == 'Y'){
      let dealerData = {
        "dealer" : this.selectedDealer
      }
      this.deleteDealer(dealerData);
    }

    let selectedVendorCodeList = this.vendorCodeList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('here 2');
    let selectedCustList = this.customerList.filter(function(tag) {
      return tag.SELECTED == true;
    }); 

    console.log('here 3');
    // Create some objects
    let dealerData = { 
      dealer: this.selectedDealer, 
      vendor: selectedVendorCodeList, 
      customer: selectedCustList
    };

    console.log('here 4');
    //Add item to list
    this.popupDealerDetailList.push(dealerData);

    if(deleteFlag == 'Y'){
      this.confirmDealerUpdateModalRef.hide();
    }
    console.log('here 5' + this.popupDealerDetailList);
  }

  deleteDealer(dealerData){
    //this.popupDealerDetailList = this.popupDealerDetailList.filter(item => item.id !== dealerData.dealer.DEALER_ID);

    let newPopUpDealerDetailList = [];

    this.popupDealerDetailList.filter(
      item => {
          console.log('dealerData.dealer.DEALER_ID:' + dealerData.dealer.DEALER_ID + "*");
          console.log('item.dealer.DEALER_ID:' + item.dealer.DEALER_ID + "*");
          console.log("condition:" + item.dealer.DEALER_ID != dealerData.dealer.DEALER_ID);
          if(dealerData.dealer.DEALER_ID != item.dealer.DEALER_ID ){
            console.log("Do not match");
            newPopUpDealerDetailList.push(item);
          }else{
            console.log("Match!!");
          }
          
      });

       this.popupDealerDetailList = newPopUpDealerDetailList;
    console.log('Here 1 : ' + this.popupDealerDetailList);
  }

  saveDealer(){

    if(this.popupDealerDetailList.length == 0){
      this.dealerErrorDetails = { ...this.dealerErrorDetails, missingDealer: 'Please add dealer details.' };
      return;
    }
    this.mainDealerDetailList = JSON.parse(JSON.stringify(this.popupDealerDetailList));

    this.roles.forEach(role => {
      role.SELECTED = false;
    });

    this.copyUserFlag = 'N';
    this.closeModal('dealer');
  }

  validateCreateUser(){
    this.errorDetails = {};

    //Check if email is available and valid
    if(this.emailAddr === ''){
      this.errorDetails = { ...this.errorDetails, missingEmail: 'Please provide an email address.' };
    }else if(!this.util.validateEmail(this.emailAddr)){
      this.errorDetails = { ...this.errorDetails, invalidEmail: 'Please provide a valid email address.' };
    }

    //Check if roles is selected
    let selectedRoles = this.roles.filter(function(tag) {
      return tag.SELECTED == true;
    });     

    if(selectedRoles.length == 0){
      this.errorDetails = { ...this.errorDetails, missingRole: 'Please select a role.' };
    }

    //Check if dealer data is available
    if(this.mainDealerDetailList.length == 0){
      this.errorDetails = { ...this.errorDetails, missingDealer: 'Please select Dealer details.' };
    }

    if(Object.keys(this.errorDetails).length !== 0){
      return;
    }else{
      this.confirmCreateUserModalRef = this.modalService.show(this.confirmCreateUserTemplate, { backdrop : 'static', keyboard : false});
    }
  }

  createUser(){

     this.blockUI.start();

    this.confirmCreateUserModalRef.hide();

    let commaSeparatedRoleCodes :string = '';
    let dealerDetails = [];
    let userName = '';

    if(this.copyUserFlag == 'N'){
      //Check if roles is selected
      let selectedRoles = this.roles.filter(function(tag) {
        return tag.SELECTED == true;
      });  

      //Get the role code comma seperated string
      const roleCodes = selectedRoles.map(role => role.ROLE_CODE);
      commaSeparatedRoleCodes = roleCodes.join(','); 

      //Get dealer details with just the ids
      dealerDetails = this.mainDealerDetailList.map((item) => ({
        dealerId: item.dealer.DEALER_ID,
        vendorIds : item.vendor.map(v => v.VENDOR_CODE_ID).join(','),
        customerIds : item.customer.map(c => c.CUST_ACCOUNT_ID).join(',')

      }));
    }else{
     // userName = this.copyUser.USER_NAME;
     let selectedRoles = this.roles.filter(function(tag) {
        return tag.SELECTED == true;
      });  

      //Get the role code comma seperated string
      const roleCodes = selectedRoles.map(role => role.ROLE_CODE);
      commaSeparatedRoleCodes = roleCodes.join(','); 

      //Get dealer details with just the ids
      dealerDetails = this.mainDealerDetailList.map((item) => ({
        dealerId: item.DEALER_ID,
        vendorIds : item.VENDOR_CODE_ID,
        customerIds : item.CUST_ACCOUNT_ID

      }));
    }

    let param = {
      "RECORD_ID" : this.recordId,
      "EMAIL_ADDRESS" : this.emailAddr,
      "DEALER_DETAILS": dealerDetails,
      "ROLES" : commaSeparatedRoleCodes,
      "USER_NAME" : userName
    }

    this.userAccessService.createUser(param).subscribe(data => {

      this.createStatusMsg = data.message;

      this.createStatusFlag= data.flag;

       this.blockUI.stop();

      this.createStatusModalRef = this.modalService.show(this.createStatusTemplate, { backdrop : 'static', keyboard : false});
  
    },
    error => {
      this.createStatusMsg = 'An error occurred while creating the user. Please try again.';
      this.createStatusFlag = 'E';
      this.blockUI.stop();
      this.createStatusModalRef = this.modalService.show(this.createStatusTemplate, { backdrop: 'static', keyboard: false });
    }
  );

  }

  searchUser(){

    this.searchUserMessage = '';
    
    if(!this.userNameSearch.trim()){
      this.searchUserMessage = 'Please provide user name';
      return;
    }

    this.blockUI.start();
    let param = {
      "USER_TEXT" : this.userNameSearch.trim()
    }

    this.userAccessService.getUserList(param).subscribe(data => {

      if(data.status == 'S'){
        this.userNameList = data.userList;
        this.totalUser = this.userNameList.length;
      }else{
        //this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }  
      //this.tableLoader = false;    
      this.blockUI.stop();
    }); 
  }

  displayConfirmCopyUserPopup(userData){

    this.confirmCopyUserMsg = 'Do you want to Copy the access privileges of user ' + userData.USER_NAME + ' to the new user?'

    this.confirmCopyUserModalRef = this.modalService.show(this.confirmCopyUserTemplate, { backdrop : 'static', keyboard : false});
  
  }

  getUserDealerDetails(userData){

    this.blockUI.start();

    this.copyUser = userData;

    if (userData.SELECTED == true) {
      userData.SELECTED = false;
    }else if(userData.SELECTED == false){
      userData.SELECTED = true; 
    }

    //get the user dealer details
    let param = {
      "USER_NAME" : this.copyUser.USER_NAME
    }

    this.userAccessService.getUserDealerDetails(param).subscribe(data => {

      if(data.status == 'S'){

        this.copyUserFlag = 'Y';

        this.mainDealerDetailList = data.dealerList;
        
        let copyUserRolesCodes = data.roleCodes;

        this.roles.forEach(role => {
          let roleCode : string = role.ROLE_CODE;
          console.log('copyUserRolesCodes:' + copyUserRolesCodes);
          console.log('roleCode:' + roleCode);
          if(copyUserRolesCodes.includes(roleCode)){
            role.SELECTED = true;
            console.log('Match');
          }else{
            role.SELECTED = false;
            console.log('Do Not Match');

          }
        });

        this.copyUserModalRef.hide();
      }else{
        this.copyUserModalRef.hide();
        //this.rejectStatusMsg = 'Access Request for email address - ' + this.selectedUserRequest.EMAIL_ADDRESS + ' could not be processed';
      }  
      //this.tableLoader = false;    
       this.blockUI.stop();
    });

    

  }

  openCopyUserModal(){
    console.log('after openCopyUserModal');

    //this.copyUserFlag = 'Y';

    this.copyUser = {};

    this.userNameSearch = '';

    this.userNameList = [];
    this.totalUser = -1;

    this.popupDealerDetailList = [];

    this.copyUserModalRef = this.modalService.show(this.copyUserTemplate, { backdrop : 'static', keyboard : false});

  }

 
}
